export default {
	namespaced: true,
	state: {
		list: [],
	},

	mutations:{
		setList(state, payload){
			state.list=payload
		},
	},
	getters:{
		getList(state) {
			return state.list
		}
	},
	actions: {
		/*toggleSidebar({state, commit, dispatch}) {
			commit('setIsShowedSidebar', !state.isShowedSidebar)
		}*/
	},

}